import cn from "classnames";
import { Datetime } from "components/shared/form";
import { bidPointTypesEnum, featureModuleTypesEnum } from "helpers/enums";
import { requiredField } from "helpers/validators";
import moment from "moment";
import React, { useEffect, useState } from "react";

const PlanLeaveDate = (props) => {
    const { isDisabled, value, utcTimezone, onChange, i, type, availableFeatureModules, planEnterDate } = props;
    const [lastValue, setLastValue] = useState(value);

    useEffect(() => {
        if (value) {
            setLastValue(value);
        }
    }, [value]);

    const renderDateField = (fieldProps) => (
        <Datetime
            {...fieldProps}
            inPortal
            wrapper="col-auto"
            errorWrapper="col-sm-8 col-md-9 offset-sm-4 offset-md-3"
            label="Дата выезда"
            inputProps={{
                name: "planLeaveDate",
                type: "datetime",
            }}
            libOptions={{ disabled: isDisabled }}
            index={i}
            onChange={onChange}
            value={value}
            additionalText={utcTimezone}
            required
            validators={[requiredField]}
        />
    );
    if (bidPointTypesEnum.CustomPoint === type) {
        return renderDateField();
    }
    if (availableFeatureModules.includes(featureModuleTypesEnum.BidPointPlanningLeaveDate)) {
        const togglePlanLeaveDate = () => {
            const newValue = value ? null : lastValue || moment(planEnterDate).add(1, "hours").format();
            onChange({ name: "planLeaveDate", value: newValue });
        };
        return (
            <>
                {value && renderDateField({ bWrapper: "row" })}
                <div className="row form-group">
                    <div className="col-sm-8 col-md-9 offset-sm-4 offset-md-3">
                        <div className="col-form-label-sm" onClick={togglePlanLeaveDate}>
                            <div className={cn("checkbox d-inline-block", { "checkbox--checked": value })} />
                            &nbsp;
                            <div className="d-inline-block checkbox__text">Изменить плановую дату выезда</div>
                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        return null;
    }
};

export default PlanLeaveDate;
